export default () => ({
    path : window.location.pathname,
    isNotSettingsPage() {
        if ((this.path === "/user/settings") || (this.path === "/user/licenses")) {
            return false
        }
        return true
    }
})